module.exports = __webpack_public_path__ + "media/dietro-le-quinte.189dd8cc.mp4";